import { render, staticRenderFns } from "./OtherDetail.vue?vue&type=template&id=e00868ac&scoped=true&"
import script from "./OtherDetail.vue?vue&type=script&lang=ts&"
export * from "./OtherDetail.vue?vue&type=script&lang=ts&"
import style0 from "./OtherDetail.vue?vue&type=style&index=0&id=e00868ac&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e00868ac",
  null
  
)

export default component.exports